import { useParams, Link } from "react-router-dom";
import { useState } from "react";
import Breadcrumb from "@/components/feature/Breadcrumb";
import CategoryNav from "@/pages/home/components/CategoryNav";
import ComicCard from "@/components/feature/ComicCard";
import { comics, type Comic } from "@/mocks/comics";
import { categories, getCategoryBySlug } from "@/mocks/categories";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = slug ? getCategoryBySlug(slug) : categories[0];
  const [sortBy, setSortBy] = useState<"latest" | "popular" | "rating">("latest");

  const filteredComics: Comic[] = category.slug === "all"
    ? [...comics]
    : comics.filter((c) => c.category === category.slug);

  const sortedComics = [...filteredComics].sort((a, b) => {
    if (sortBy === "latest") return new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime();
    if (sortBy === "popular") return b.views - a.views;
    return b.rating - a.rating;
  });

  const breadcrumbItems = [
    { label: "首页", href: "/" },
    { label: category.name },
  ];

  const currentUrl = `https://hanmanonline.com/category/${category.slug}`;

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: `${category.name}韩国漫画 - 韩漫在线`,
            description: `韩漫在线为您提供${category.name}类型的韩国漫画免费在线阅读，精选优质韩漫作品，每日更新。`,
            url: currentUrl,
            isPartOf: {
              "@type": "WebSite",
              name: "韩漫在线",
              url: "https://hanmanonline.com",
            },
          }),
        }}
      />
      <div className="pt-20">
        <Breadcrumb items={breadcrumbItems} />
        <div className="py-6">
          <CategoryNav activeSlug={category.slug} />
        </div>
        <div className="w-full px-4 md:px-6 py-8">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
              <div>
                <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                  {category.name}漫画
                </h1>
                <p className="text-sm text-foreground-500 mt-1">
                  共 {filteredComics.length} 部作品
                </p>
              </div>
              <div className="flex items-center gap-2 bg-background-100 rounded-full p-1">
                {[
                  { key: "latest", label: "最新" },
                  { key: "popular", label: "最热" },
                  { key: "rating", label: "评分" },
                ].map((s) => (
                  <button
                    key={s.key}
                    onClick={() => setSortBy(s.key as typeof sortBy)}
                    className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                      sortBy === s.key
                        ? "bg-primary-500 text-background-50"
                        : "text-foreground-600 hover:text-foreground-900"
                    }`}
                  >
                    {s.label}
                  </button>
                ))}
              </div>
            </div>
            {sortedComics.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
                {sortedComics.map((comic) => (
                  <ComicCard key={comic.id} comic={comic} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-20 h-20 mx-auto mb-4 bg-background-100 rounded-full flex items-center justify-center">
                  <i className="ri-emotion-sad-line text-foreground-400 text-3xl w-8 h-8 flex items-center justify-center"></i>
                </div>
                <p className="text-foreground-500">该分类暂无漫画，敬请期待</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}